<template>
    <div class="aboutus-section section-space--pt_60 section-space--pb_120" id="partner">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="brand-details-wrap">
                        <img src="@/assets/static-img/features/about-us-img.png" class="img-fluid" alt="">   
                        <!-- <h4 class="heading mb-10 wow move-up">About Us</h4>                     
                        <p class="text section-space--mb_40 wow move-up">We are an online service provider focusing on helping small businesses to build online presence and growing online stores. We are here to help you to connect your store with mobile messaging apps. By using QuickSend, you can easily showcase your online store and products to customers while interacting with them through WhatsApp, Telegram or WeChat.</p>
                        <router-link to="/app-landing" class="ht-btn ht-btn-md">View all clients</router-link> -->
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="brand-details-wrap" style="max-width: initial;">
                        <h4 class="heading mb-10 wow move-up">About Us</h4>
                        <p class="text wow move-up">We are an online service provider focusing on helping small businesses to build online presence and growing online stores. We are here to help you to connect your store with mobile messaging apps. By using QuickSend, you can easily showcase your online store and products to customers while interacting with them through WhatsApp, Telegram or WeChat.</p>
                    </div>
                    <!-- Use here if future would add partner logo -->
                    <!-- <div class="row brand-logo-wrapper">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-6 brand-logo wow move-up">
                            <div class="app-landing-brand-logo__image">
                                <a href="#"><img src="../assets/img/brand/aeroland-app-landing-client-logo-01.png" class="img-fluid" alt=""></a>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-6 brand-logo wow move-up">
                            <div class="app-landing-brand-logo__image">
                                <a href="#"><img src="../assets/img/brand/aeroland-app-landing-client-logo-02.png" class="img-fluid" alt=""></a>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-6 brand-logo wow move-up">
                            <div class="app-landing-brand-logo__image">
                                <a href="#"><img src="../assets/img/brand/aeroland-app-landing-client-logo-03.png" class="img-fluid" alt=""></a>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-6 brand-logo wow move-up">
                            <div class="app-landing-brand-logo__image">
                                <a href="#"><img src="../assets/img/brand/aeroland-app-landing-client-logo-04.png" class="img-fluid" alt=""></a>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-6 brand-logo wow move-up">
                            <div class="app-landing-brand-logo__image">
                                <a href="#"><img src="../assets/img/brand/aeroland-app-landing-client-logo-05.png" class="img-fluid" alt=""></a>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-6 brand-logo wow move-up">
                            <div class="app-landing-brand-logo__image">
                                <a href="#"><img src="../assets/img/brand/aeroland-app-landing-client-logo-06.png" class="img-fluid" alt=""></a>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Partnership',
    };
</script>